import { FC, ReactText, useEffect, useState } from "react";
import {
  IntputWrapperBig,
  IntputWrapperBigHalf,
  LoginFormSection,
  LoginSubtitle,
} from "../Login.styles";
import { Aligment, Button, Checkbox, Dropdown, Input } from "venice-ui";
import { getLang, t } from "../../../helpers/userHelper";
import { dictionary } from "../../../untils/dictionary";
import {
  getCountryScopeByLang,
  isEuCountry,
} from "../../../helpers/countryHelpers";
import { apiCall } from "../../../untils/apiCall";
import { pageTitle } from "../../../untils/const";

interface IRegisterPaymentDetails {
  companyName: string;
  companyAdressLine1: string;
  companyPostCode: string;
  companyCity: string;
  companyCountry: string;
  companyNip: number | undefined;
  handleChange: (name: string, value: ReactText) => void;
  clearDetails: () => void;
  extraTaxNumerber: string;
  isCompany: boolean;
  isWaiverOfTheRightToWithdraw: boolean;
  handleToogle: (name: string, value: boolean) => void;
  pricePlanID:string
}

export const RegisterPaymentDetails: FC<IRegisterPaymentDetails> = ({
  companyName,
  companyAdressLine1,
  companyPostCode,
  companyCity,
  companyCountry,
  companyNip,
  handleChange,
  handleToogle,
  clearDetails,
  extraTaxNumerber,
  isCompany,
  isWaiverOfTheRightToWithdraw,
  pricePlanID
}) => {
  const [pageData, setPageData] = useState({
    isEuCountry: false,
    vatEuCode: "",
    vatStatus: "",
  });
  const [checkingLoader, setCheckingLoader] = useState(false);
  useEffect(() => {
    setPageData({
      isEuCountry: false,
      vatEuCode: "",
      vatStatus: "",
    });
  }, [pricePlanID]);

  const countryChange = (name: string, value: ReactText) => {
    setPageData({
      ...pageData,
      isEuCountry: isEuCountry(value as string),
      vatStatus: "",
    });
    handleChange("companyCountry", value);
  };

  const handleVatStatus = (name: string, value: ReactText) => {
    setPageData({
      ...pageData,
      vatEuCode: value as string,
      vatStatus: "",
    });
    if (
      companyName ||
      companyAdressLine1 ||
      companyPostCode ||
      companyCity ||
      companyNip
    ) {
      clearDetails();
    }
  };

  const vatEuValidation = async () => {
    const options = {
      vatNumber: companyCountry + pageData.vatEuCode,
    };
    setCheckingLoader(true);
    await apiCall("auth/checkVatEU", options, (response: any) => {
     
      if (
        response.data.valid  || pageTitle === "stg"
      ) {
        handleChange("companyNip", pageData.vatEuCode);
        setPageData({
          ...pageData,
          vatStatus: "valid",
        });
         setCheckingLoader(false);
        if (response.data.name && response.data.name !== "---") {
          handleChange("companyName", response.data.name);
        }
      } else if (!response.data.valid) {
        setPageData({
          ...pageData,
          vatStatus: "invalid",
        });
         setCheckingLoader(false);
      }
    });
  };

  useEffect(() => {
    setPageData({
      ...pageData,
      isEuCountry: isEuCountry(companyCountry),
    });
  }, []);

  const handleiSCompanyCheckboxChange = (value: boolean) => {
    handleToogle("isCompany", value);
  };
  const handleWaiverOfTheRightToWithdrawCheckboxChange = (value: boolean) => {
    handleToogle("isWaiverOfTheRightToWithdraw", value);
  };

  return (
    <>
      <LoginSubtitle>{t(dictionary.invoiceData)}</LoginSubtitle>
      <LoginFormSection>
        <IntputWrapperBig>
          <Dropdown
            label={t(dictionary.companyCountry)}
            labelPosition="top"
            value={companyCountry}
            options={getCountryScopeByLang(getLang(navigator.language))}
            handleSelect={(name: string, value: ReactText) =>
              countryChange(name, value as string)
            }
            name="companyCountry"
            maxHeight={"200px"}
            placeholder={t(dictionary.selectCountry)}
          />
        </IntputWrapperBig>
        {companyCountry && pageData.isEuCountry && (
          <IntputWrapperBig>
            <Aligment direction="rcolumnow" wrap="nowrap">
              <Input
                label={t(dictionary.companyNip)}
                type="text"
                labelPosition="top"
                value={companyNip}
                name="companyNip"
                handleChange={(name: string, value: ReactText) =>
                  handleVatStatus(name, (value as string).trim())
                }
                prefix={pageData.isEuCountry ? companyCountry : undefined}
                error={pageData.vatStatus === "invalid"}
                errorMsg={
                  pageData.vatStatus === "invalid"
                    ? t(dictionary.invalidVatNumber)
                    : ""
                }
                autoFocus={true}
              />
            </Aligment>
            {pageData.vatStatus !== "valid" &&
              pageData.vatEuCode.length > 0 && (
                <Button
                  onClick={vatEuValidation}
                  text={t(dictionary.checkVat)}
                  mode="secondary"
                  disabled={pageData.vatEuCode.length === 0}
                  loader={checkingLoader}
                />
              )}
          </IntputWrapperBig>
        )}
        {companyCountry && !pageData.isEuCountry && (
          <IntputWrapperBig>
            <Input
              label={t(dictionary.extraTaxNumber)}
              type="text"
              labelPosition="top"
              value={extraTaxNumerber}
              name="extraTaxNumerber"
              handleChange={(name: string, value: ReactText) =>
                handleChange(name, value as string)
              }
              autoFocus={true}
            />
          </IntputWrapperBig>
        )}
        {companyCountry &&
          ((pageData.isEuCountry && pageData.vatStatus === "valid") ||
            !pageData.isEuCountry) && (
            <>
              <IntputWrapperBig>
                <Input
                  label={t(dictionary.companyName)}
                  type="text"
                  labelPosition="top"
                  value={companyName}
                  name="companyName"
                  handleChange={(name: string, value: ReactText) =>
                    handleChange(name, value as string)
                  }
                  autoFocus={true}
                />
              </IntputWrapperBig>
              <IntputWrapperBig>
                <Input
                  label={t(dictionary.companyAdressLine1)}
                  type="text"
                  labelPosition="top"
                  value={companyAdressLine1}
                  name="companyAdressLine1"
                  handleChange={(name: string, value: ReactText) =>
                    handleChange(name, value as string)
                  }
                />
              </IntputWrapperBig>
              <Aligment direction="row" gap={16} wrap="wrap">
                <IntputWrapperBigHalf>
                  <Input
                    label={t(dictionary.companyPostCode)}
                    type="text"
                    labelPosition="top"
                    value={companyPostCode}
                    name="companyPostCode"
                    handleChange={(name: string, value: ReactText) =>
                      handleChange(name, value as string)
                    }
                  />
                </IntputWrapperBigHalf>
                <IntputWrapperBigHalf>
                  <Input
                    label={t(dictionary.companyCity)}
                    type="text"
                    labelPosition="top"
                    value={companyCity}
                    name="companyCity"
                    handleChange={(name: string, value: ReactText) =>
                      handleChange(name, value as string)
                    }
                  />
                </IntputWrapperBigHalf>
              </Aligment>
              <IntputWrapperBig>
                <Aligment direction="row" gap={16} wrap="wrap">
                  <Checkbox
                    size="small"
                    value={isCompany}
                    handleClick={(value: boolean) =>
                      handleiSCompanyCheckboxChange(value as boolean)
                    }
                    labelPosition={"left"}
                    label={t(dictionary.openAccounctAsCompany)}
                    width="auto"
                  />
                  <Checkbox
                    size="small"
                    value={isWaiverOfTheRightToWithdraw}
                    handleClick={(value: boolean) =>
                      handleWaiverOfTheRightToWithdrawCheckboxChange(
                        value as boolean,
                      )
                    }
                    labelPosition={"left"}
                    label={t(dictionary.waiverOfTheRightToWithdraw)}
                    width="auto"
                  />
                </Aligment>
              </IntputWrapperBig>
            </>
          )}
      </LoginFormSection>
    </>
  );
};
